import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import localforage from 'localforage';
import storageSession from 'redux-persist/lib/storage/session'

import mainReducer from '../_reducers/main.reducer';
import searchReducer from '../_reducers/search.reducer';
import authenticationReducer from '../_reducers/authentication.reducer';
import usersReducer from '../_reducers/users.reducer';
import alertReducer from '../_reducers/alert.reducer';
import investmentReducer from '../_reducers/investment.reducer';
import favoriteReducer from '../_reducers/favorite.reducer';
import fundRankingReducer from '../_reducers/fund-ranking.reducer';
import advanceSearchReducer from '../_reducers/advance-search.reducer';
import hotfundReducer from '../_reducers/hotfund.reducer';
import compareReducer from '../_reducers/compare.reducer';
import informationReducer from '../_reducers/information.reducer';
import orderRequestReducer from '../_reducers/order-request.reducer';
import ipoReducer from '../_reducers/ipo.reducer';
import monthlyReportReducer from '../_reducers/monthly-report.reducer';
import calendarReducer from '../_reducers/calendar.reducer';
import transferReducer from '../_reducers/transfer.reducer';
import homeReducer from '../_reducers/home.reducer';
import generalReducer from '../_reducers/general.reducer';

const sessionConfig = (name, data) => {
  const authPersistConfig = {
    key: name,
    storage: storageSession,
  };

  return persistReducer(authPersistConfig, data)
}

const persistConfig = {
  key: 'root',
  storage: localforage,
  //whitelist: ['main', 'authentication']
};

let reducers = {
  main: mainReducer,
  search: searchReducer,
  authentication: authenticationReducer,
  users: usersReducer,
  alert: alertReducer,
  information: informationReducer,
  investment: sessionConfig('investment', investmentReducer),
  favorite: sessionConfig('favorite', favoriteReducer),
  advanceSearch: sessionConfig('advanceSearch', advanceSearchReducer),
  hotfund: hotfundReducer,
  compare: sessionConfig('compare', compareReducer),
  orderRequest: orderRequestReducer,
  ipo: ipoReducer,
  monthlyReport:  sessionConfig('monthlyReport', monthlyReportReducer),
  calendar: calendarReducer,
  transfer: transferReducer,
  home: homeReducer,
  fundRanking: sessionConfig('fundRanking', fundRankingReducer),
  general: generalReducer//sessionConfig()
};

const rootReducer = combineReducers({
  ...reducers
});

export default persistReducer(persistConfig, rootReducer);
